
import { Options, Vue } from 'vue-class-component';
import { applicationModule } from '@/store/application';
import { getSettingsItems } from '@/store/menu';
import SidebarMenu from './SidebarMenu.vue';

@Options({
  name: 'SettingsMenu',
  components: { SidebarMenu }
})
export default class SettingsMenu extends Vue {
  get applicationModule() {
    return applicationModule;
  }

  get menuItems() {
    return getSettingsItems().map((item) => {
      return {
        title: this.$t(item.i18n, 'f'),
        ...item
      };
    });
  }
}
